module.exports = __webpack_public_path__ + "img/auth_bg.af0e5dcd.png";